export const products = [
  {
    id: 1,
    name: "AQcet-M Tablet",
    brand: "AQcet-M",
    composition: "Levocetirizine Hydrochloride 5 mg, Montelukast Sodium 10 mg",
    category: "Anti cold / Anti Pyratics",
    packSize: "-",
    packing: "10*10 Alu Alu",
    image: ""
  },
  {
    id: 2,
    name: "AQflam-SP Tablet",
    brand: "AQflam-SP",
    composition: "Aceclofenac I.P. 100 mg, Paracetamol I.P. 325 mg, Serratiopeptidase I.P. 15 mg",
    category: "Anti-analgesic",
    packSize: "-",
    packing: "10*10 Alu Alu",
    image: ""
  },
  {
    id: 3,
    name: "AQpan-DSR Tablet",
    brand: "AQpan-DSR",
    composition: "Pantoprazole Sodium I.P. 40 mg (Gastro-resistant pellets), Domperidone I.P. 30 mg (Prolonged-release pellets)",
    category: "Anti-ulcerants & Anti-nauserants",
    packSize: "-",
    packing: "10*10 Alu Alu",
    image: ""
  },
  {
    id: 4,
    name: "AQflox-O Tablet",
    brand: "AQflox-O",
    composition: "Ofloxacin I.P. 200 mg, Ornidazole I.P. 500 mg",
    category: "Anti-biotics",
    packSize: "-",
    packing: "10*10 Alu Alu",
    image: ""
  },
  {
    id: 5,
    name: "AQcef-200LB Tablet",
    brand: "AQcef-200LB",
    composition: "Cefixime (Trihydrate) I.P. 200 mg, Lactic Acid Bacillious 60 million spores",
    category: "Anti-biotics",
    packSize: "-",
    packing: "10*10",
    image: ""
  },
  {
    id: 6,
    name: "AQkuff-AM Syrup",
    brand: "AQkuff-AM",
    composition: "Ambroxol Hydrochloride I.P. 15 mg, Guaiphenesin I.P. 50 mg, Terbutaline Sulphate I.P. 1.25 mg",
    category: "Expectorant / Cough Syrup",
    packSize: "100 ml",
    packing: "-",
    image: "AQkuff-AM.png",
    batchNumber:"BL24063"
  },
  {
    id: 7,
    name: "AQkuff-DX Syrup",
    brand: "AQkuff-DX",
    composition: "Dextromethorphan Hydrobromide I.P. 15 mg, Phenylephrine Hydrochloride I.P. 5 mg, Chlorpheniramine Maleate 2 mg",
    category: "Expectorant / Cough Syrup",
    packSize: "100 ml",
    packing: "-",
    image: "AQkuff-DX.png",
    batchNumber:"BL24062"
  },
  {
    id: 8,
    name: "AQkuff-LS Syrup",
    brand: "AQkuff-LS",
    composition: "Levosalbutamol Sulphate I.P. 1 mg, Ambroxol Hydrochloride I.P. 30 mg, Gualphenesin I.P. 50 mg",
    category: "Expectorant / Cough Syrup",
    packSize: "100 ml",
    packing: "-",
    image: ""
  },
  {
    id: 9,
    name: "TELMIUS-40 Tablet",
    brand: "TELMIUS-40",
    composition: "Telmisartan I.P. 40 mg",
    category: "Cardiac & Diabetic",
    packSize: "-",
    packing: "10*15 Alu Alu",
    image: ""
  },
  {
    id: 10,
    name: "TELMIUS-AM Tablet",
    brand: "TELMIUS-AM",
    composition: "Telmisartan I.P. 40 mg, Amlodipine Besilate I.P. 5 mg",
    category: "Cardiac & Diabetic",
    packSize: "-",
    packing: "10*15 Alu Alu",
    image: ""
  },
  {
    id: 11,
    name: "DIABIUS-M1 Tablet",
    brand: "DIABIUS-M1",
    composition: "Glimepiride I.P. 1 mg, Metformin Hydrochloride I.P. 500 mg",
    category: "Cardiac & Diabetic",
    packSize: "-",
    packing: "10*10 Alu Alu",
    image: ""
  },
  {
    id: 12,
    name: "Viteus-Forte Tablet",
    brand: "Viteus-Forte",
    composition: "Methycobalamine I.P. 1500 mg, Alpha Lipoic Acid USP 100 mg, Vitamin D3 I.P. 2000 IU, Pyridoxine Hydrochloride I.P. 5 mg, Folic Acid I.P. 5 mg",
    category: "Anti-oxidents / Multivitamin & Multi mineral",
    packSize: "-",
    packing: "10*10 Alu Alu",
    image: ""
  }
];